/* @ngInject */
function CampaignMaterialFloatingToolBarController ($rootScope, $scope, $timeout) {
  const api = {
  }
  this.getApi = () => api

  activate()

  function activate () {
  }

  $scope.attachTemplatesMaterialActions = (selectedMaterials) => {
    $rootScope.$emit('campaign.change-tab-action', 'tab-7')
    /**
     * Emitido com timeout para dar tempo da tab carregar (caso não tenha sido pré-ativada antes).
     */
    $timeout(() => {
      if ($scope.action) {
        $rootScope.$emit('campaign.attach-material-actions', [...selectedMaterials])
      } else {
        $rootScope.$emit('campaign.attach-material-new-action', [...selectedMaterials])
      }

      $rootScope.$emit('campaign.select-material-floating-tool-bar', { materials: [], action: null })
    }, 100)
  }

  $scope.unselectMaterials = () => {
    $rootScope.$emit('campaign.select-material-floating-tool-bar', { materials: [], action: $scope.action })
  }
}

export { CampaignMaterialFloatingToolBarController }
